import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';

// store
import { useStoreValue } from '../../../../../../store';

// components
import PlusIcon from '../../../../../../icons/PlusIcon';
import ModalUploadSimple from '../../../../../../components/ModalUploadSimple';
import ModalUploadCueSheetWithClip from '../../../../../../components/ModalUploadCueSheetWithClip';
import ListOfReferenceItems from '../MusicList/components/ListOfReferenceItems';
import ListOfSoundtrackItems from './components/ListOfSoundtrackItems';

const MusicList = () => {
    const { projectId } = useParams();
    const myStudioLeftPanel = useStoreValue('myStudioLeftPanel');
    const myStudioMusicPanel = useStoreValue('myStudioMusicPanel');
    const [showUploadModal, setShowUploadModal] = useState(false);

    return (
        myStudioLeftPanel === 'music'
            ? <>
                <OverlayScrollbarsComponent element="div" options={{ scrollbars: { autoHide: 'never' } }} defer>
                    <ul className="timelineEditorAuxControls__listOfTracks">
                        {myStudioMusicPanel === 'references'
                            ? <ListOfReferenceItems/> : null}
                        {myStudioMusicPanel === 'soundtrack'
                            ? <ListOfSoundtrackItems/> : null}
                    </ul>
                </OverlayScrollbarsComponent>
                <button className="timelineEditorAuxControls__addNew" onClick={() => setShowUploadModal(true)}>
                    <PlusIcon/>
                </button>
                {showUploadModal && myStudioMusicPanel === 'references' && (
                    <ModalUploadSimple
                        projectId={projectId}
                        type="references"
                        headerText="Carica Reference"
                        onClose={() => setShowUploadModal(false)}
                    />
                )}
                {showUploadModal && myStudioMusicPanel === 'soundtrack' && (
                    <ModalUploadCueSheetWithClip
                        projectId={projectId}
                        cueType="MUSIC"
                        headerText="Carica Soundtrack"
                        onClose={() => setShowUploadModal(false)}
                    />
                )}
            </> : null
    );
};

export default MusicList;
